import { useLayoutEffect, useEffect, useState, useRef } from "react";
import styles from "@/components/ui/tooltip/ToolTip.module.css";
import classNames from "classnames";

const Tooltip = ({ children, tooltipText }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [persistent, setPersistent] = useState(false);
  const tooltipRef = useRef(null);

  useLayoutEffect(() => {
    const tooltip = tooltipRef.current;
    if (tooltip) {
      const rect = tooltip.getBoundingClientRect();
      const overflowRight = rect.right > window.innerWidth;
      const overflowLeft = rect.left < 0;

      if (overflowRight) {
        tooltip.style.right = `${0}px`;
        tooltip.style.transform = `translateX(0)`;
        console.log("right");
      } else if (overflowLeft) {
        tooltip.style.left = `${0}px`;
        tooltip.style.transform = `translateX(0)`;
        console.log("left");
      } else {
        tooltip.style.right = `initial`;
        tooltip.style.left = `50%`;
        tooltip.style.transform = `translateX(-50%)`;
      }

      tooltip.style.bottom = `${100}%`;
      tooltip.style.opacity = "0.9";
    }
  }, [showTooltip]);

  const handleClick = () => {
    setPersistent(!persistent);
    setShowTooltip(true);
  };

  const onTooltipClick = (event) => {
    event.stopPropagation();
    setPersistent(false);
    setShowTooltip(false);
  };

  const handleMouseEnter = () => {
    if (!("ontouchstart" in window) && !persistent) {
      setShowTooltip(true);
    }
  };

  const handleMouseLeave = () => {
    if (!("ontouchstart" in window) && !persistent) {
      setShowTooltip(false);
    }
  };

  // Close the tooltip if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setPersistent(false);
        setShowTooltip(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={classNames(styles.tooltip, { [styles.active]: showTooltip })}
      onClick={handleClick}
      onTouchEnd={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {children}
      {showTooltip && (
        <span
          className={styles.tooltiptext}
          ref={tooltipRef}
          onClick={onTooltipClick}>
          {tooltipText}
        </span>
      )}
    </div>
  );
};

export default Tooltip;
